// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"172":"component---src-pages-terms-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"172":"d26e1e81c4d6fa56919b","678":"95f34c0f1c8fa6cd9dc6"}[chunkId] + ".js";
};